import React, { useState, useEffect, useRef, useMemo } from "react";
import styles from "./dropdown.module.css";
import arrow from "../../../widgets/formSection/images/icon.png";
import RadioButton from "@/shared/ui/RadioButton/index.js";

const Dropdown = ({
                      options = [],
                      placeholder = "Выберите элемент",
                      selected = null,
                      onSelect = () => {},
                      getLabel = (option) => option?.label || "",
                      getValue = (option) => option?.id || "",
                      renderDescription = null,
                      name = "custom-dropdown",
                  }) => {
    const [internalSelected, setInternalSelected] = useState(selected);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        setInternalSelected(selected);
    }, [selected]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (option) => {
        setInternalSelected(option);
        onSelect(option);
        setIsOpen(false);
    };

    const renderedOptions = useMemo(() => {
        return options.map((option) => {
            const label = getLabel(option);
            const value = getValue(option);
            const isChecked = internalSelected ? getValue(internalSelected) === value : false;

            return (
                <RadioButton
                    key={value}
                    value={value}
                    name={name}
                    isChecked={isChecked}
                    onChange={() => handleSelect(option)}
                    label={label}
                    option={option}
                    renderDescription={renderDescription}
                />
            );
        });
    }, [options, internalSelected, getLabel, getValue, renderDescription]);

    return (
        <div
            ref={dropdownRef}
            className={`${styles.dropdown} input`}
        >
            <div
                className={`d-flex justify-content-between`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {internalSelected ? getLabel(internalSelected) : placeholder}
                <span className={`${styles.arrow} ${isOpen && styles.up}`}>
                    <img src={arrow} alt="arrow" />
                </span>
            </div>
            <div className={`${styles.dropdownList} ${isOpen ? styles.dropdownListOpen : ""}`}>
                {options.length === 0 ? (
                    <p className={styles.noOptions}>Нет вариантов</p>
                ) : (
                    <div className={styles.dropdownHeader}>
                        {renderedOptions}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dropdown;
